import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import CheckboxFormFonts from './CheckboxFormFont'
import CheckboxFormStyle from './CheckboxFormStyle'
import type { CheckboxFormBrandType, CheckboxBrandForms } from './checkboxTypes'

const FORM_MAP: CheckboxBrandForms = {
  [BrandFormEnum.STYLE]: CheckboxFormStyle,
  ...CheckboxFormFonts,
}

const CheckboxFormBrand: CheckboxFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(CheckboxFormBrand) as typeof CheckboxFormBrand
